module.exports = __webpack_public_path__ + "static/media/fit-cereja.57600752.webp";